var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_show",
    transform: "translate(-218 -382)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2194",
    "data-name": "Rectangle 2194",
    width: 16,
    height: 16,
    transform: "translate(218 382)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_visible",
    d: "M13.819,8.445A6.524,6.524,0,0,0,8,5,6.524,6.524,0,0,0,2.187,8.445a1.645,1.645,0,0,0,0,1.512A6.524,6.524,0,0,0,8,13.4a6.524,6.524,0,0,0,5.816-3.445,1.644,1.644,0,0,0,0-1.512ZM8.357,10.966a1.8,1.8,0,1,1,.918-.492A1.8,1.8,0,0,1,8.357,10.966Z",
    transform: "translate(217.997 381.08)",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShow);
export default __webpack_public_path__ + "static/media/ic_show.be4e868103591bea76d086af0773e852.svg";
export { ForwardRef as ReactComponent };